// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ace_editor.ace-tm {
  background-color: var(--mnc-surface-container-lowest-color);
}

.ace_editor.ace-tm .ace_gutter {
  background-color: var(--mnc-surface-container-low-color);
}

.ace_editor.ace-tm .ace_gutter-active-line {
  background-color: var(--mnc-surface-container-highest-color);
}

.ace_editor.ace-tm .ace_active-line {
  background-color: var(--mnc-surface-container-below-color);
}

.ace_editor.ace-tm,
.ace_editor.ace-tm .ace_text-layer,
.ace_editor.ace-tm .ace_cursor,
.ace_editor.ace-tm .ace_marker-layer,
.ace_editor.ace-tm .ace_gutter {
  color: var(--mnc-on-surface-color);
}

html.mnc-mode-dark .ace_editor.ace-tm .ace_print-margin,
html.mnc-mode-dark .ace_editor.ace-tm .ace_fold-widget,
html.mnc-mode-dark .ace_editor.ace-tm .ace_meta,
html.mnc-mode-dark .ace_editor.ace-tm .ace_tag,
html.mnc-mode-dark .ace_editor.ace-tm .ace_comment,
html.mnc-mode-dark .ace_editor.ace-tm .ace_keyword,
html.mnc-mode-dark .ace_editor.ace-tm .ace_constant,
html.mnc-mode-dark .ace_editor.ace-tm .ace_string,
html.mnc-mode-dark .ace_editor.ace-tm .ace_variable,
html.mnc-mode-dark .ace_editor.ace-tm .ace_support,
html.mnc-mode-dark .ace_editor.ace-tm .ace_invalid {
  filter: invert(1) hue-rotate(180deg);
}

html.mnc-mode-dark .ace_editor.ace-tm .ace_marker-layer .ace_selection,
html.mnc-mode-dark .ace_editor.ace-tm .ace_text-layer::selection {
  background: rgba(72, 144, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/CodeEditor.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;;;;EAKE,kCAAkC;AACpC;;AAEA;;;;;;;;;;;EAWE,oCAAoC;AACtC;;AAEA;;EAEE,mCAAmC;AACrC","sourcesContent":[".ace_editor.ace-tm {\r\n  background-color: var(--mnc-surface-container-lowest-color);\r\n}\r\n\r\n.ace_editor.ace-tm .ace_gutter {\r\n  background-color: var(--mnc-surface-container-low-color);\r\n}\r\n\r\n.ace_editor.ace-tm .ace_gutter-active-line {\r\n  background-color: var(--mnc-surface-container-highest-color);\r\n}\r\n\r\n.ace_editor.ace-tm .ace_active-line {\r\n  background-color: var(--mnc-surface-container-below-color);\r\n}\r\n\r\n.ace_editor.ace-tm,\r\n.ace_editor.ace-tm .ace_text-layer,\r\n.ace_editor.ace-tm .ace_cursor,\r\n.ace_editor.ace-tm .ace_marker-layer,\r\n.ace_editor.ace-tm .ace_gutter {\r\n  color: var(--mnc-on-surface-color);\r\n}\r\n\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_print-margin,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_fold-widget,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_meta,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_tag,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_comment,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_keyword,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_constant,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_string,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_variable,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_support,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_invalid {\r\n  filter: invert(1) hue-rotate(180deg);\r\n}\r\n\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_marker-layer .ace_selection,\r\nhtml.mnc-mode-dark .ace_editor.ace-tm .ace_text-layer::selection {\r\n  background: rgba(72, 144, 255, 0.5);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
